import React from 'react';
import { CalendarDay, GetDayOnPressHandler, RenderDayContentsArgs } from './types';
import { StyleProp, View, ViewStyle } from 'react-native';
import Text from '../Text';
import { DateTime } from 'luxon';
import PressableDynamicOpacity from '../PressableDynamicOpacity';

export type DayOwnProps = {
    calendarDay: CalendarDay;
    getOnDayPressHandler?: GetDayOnPressHandler;
    renderDayContents?: (args: RenderDayContentsArgs) => React.ReactNode;
};

export type DayProps = DayOwnProps;

const Day: React.FC<DayProps> = (props) => {
    const rootStyles: StyleProp<ViewStyle> = {
        flex: 1,
        height: 34,
        marginRight: props.calendarDay.weekDayIndex === 6 ? 4 : 0,
        justifyContent: 'center',
        alignItems: 'center',
    };

    const getContent = (rootStyle: StyleProp<ViewStyle>) => (
        <View
            style={rootStyle}
            testID={`calendar-month-${props.calendarDay.monthYear.month}-day-${props.calendarDay.dayOfMonthIndex}`}
        >
            {props.renderDayContents ? (
                props.renderDayContents({
                    day: `${props.calendarDay.dayOfMonthIndex + 1}`,
                    isTargetMonth: props.calendarDay.type === 'target-month-calendar-day',
                    dateTime:
                        DateTime.fromObject({
                            year: props.calendarDay.monthYear.year,
                            month: props.calendarDay.monthYear.month,
                            day: props.calendarDay.dayOfMonthIndex + 1,
                        }).toISODate() || '',
                })
            ) : (
                <Text
                    variant="h4"
                    color={props.calendarDay.type === 'target-month-calendar-day' ? 'Dark-Text' : 'Grey-Light'}
                >
                    {props.calendarDay.dayOfMonthIndex + 1}
                </Text>
            )}
        </View>
    );

    const dayPressHandler = props.getOnDayPressHandler?.(props.calendarDay);

    return dayPressHandler ? (
        <PressableDynamicOpacity style={rootStyles} onPress={dayPressHandler}>
            {getContent({
                width: '100%',
                height: '100%',
            })}
        </PressableDynamicOpacity>
    ) : (
        getContent(rootStyles)
    );
};

export default React.memo(Day);
